import React from "react";
import styled from "styled-components";

const BlockQuote = styled.blockquote`
  text-align: justify;
  max-width: 70vw;
  margin: 0.5em;
`;

const BlockQuoteHighlight = styled.blockquote`
  text-align: justify;
  max-width: 70vw;
  margin: 0.5em;
  color: #393a3488;

  b,
  strong {
    color: #393a34;
  }
`;

export default ({ children, highlight, ...props }) => {
  return highlight ? (
    <BlockQuoteHighlight {...props}>{children}</BlockQuoteHighlight>
  ) : (
    <BlockQuote {...props}>{children}</BlockQuote>
  );
};
